module.exports = __webpack_public_path__ + "img/public/SiteIcons/lightPlusIcon.svg?cc575541";